import React from "react";
import "./OurEqual.css";
const OurEqual = () => {
  return (
    <div className="career-equal-container">
      <h1>Our Equal Opportunity Policy</h1>
      <p>
        Brick&Bolt is an equal opportunity employer. We are committed to
        providing all applicants and employees, irrespective of disability or
        any other characteristics protected under law, fair and equal access to
        jobs, benefits, training and promotions. We believe that a diverse
        workforce can broaden workplace knowledge and experience, enhance
        outputs and help generate innovative ideas and thoughts. Differently
        abled applicants may send their applications directly to the HR
        Compliance Officer at <span>hr.compliance@test.com</span>
      </p>
    </div>
  );
};

export default OurEqual;
